module.exports = __webpack_public_path__ + "img/APSicon4.40611689.png";